import axios from 'axios';

const INSTAGRAM_GRAPH_BASE_URL = 'https://graph.instagram.com';
const FACEBOOK_GRAPH_BASE_URL = 'https://graph.facebook.com';

const DEFAULT_ACCESS_TOKEN = process.env.REACT_APP_INSTAGRAM_ACCESS_TOKEN;

if (!DEFAULT_ACCESS_TOKEN) {
  console.warn('Advertencia: REACT_APP_INSTAGRAM_ACCESS_TOKEN no está configurado correctamente.');
}

const normalizeBaseUrl = (baseUrl) => (baseUrl ? baseUrl.replace(/\/+$/, '') : '');

const normalizeMetrics = (metrics) => {
  if (Array.isArray(metrics)) {
    return metrics.map((metric) => metric?.trim()).filter(Boolean).join(',');
  }
  if (typeof metrics === 'string') {
    return metrics
      .split(',')
      .map((metric) => metric?.trim())
      .filter(Boolean)
      .join(',');
  }
  return '';
};

const resolveAccessToken = (accessToken) => accessToken || DEFAULT_ACCESS_TOKEN || '';

const resolveBaseUrl = (loginType) => {
  if (loginType === 'instagram') {
    return INSTAGRAM_GRAPH_BASE_URL;
  }
  return FACEBOOK_GRAPH_BASE_URL;
};

export const getInstagramUser = async ({
  accessToken,
  loginType = 'instagram'
}) => {
  const token = resolveAccessToken(accessToken);

  if (!token) {
    throw new Error('accessToken es requerido');
  }

  const baseUrl = normalizeBaseUrl(resolveBaseUrl(loginType));
  const endpoint = `${baseUrl}/me`;

  const response = await axios.get(endpoint, {
    params: {
      fields: 'id,username',
      access_token: token
    }
  });

  return response?.data;
};

export const getInstagramAccountInsights = async ({
  instagramUserId,
  metrics,
  period,
  accessToken,
  loginType = 'facebook'
}) => {
  const normalizedMetrics = normalizeMetrics(metrics);
  const token = resolveAccessToken(accessToken);

  if (!instagramUserId) {
    throw new Error('instagramUserId es requerido');
  }
  if (!normalizedMetrics) {
    throw new Error('metrics es requerido');
  }
  if (!period) {
    throw new Error('period es requerido');
  }
  if (!token) {
    throw new Error('accessToken es requerido');
  }

  const baseUrl = normalizeBaseUrl(resolveBaseUrl(loginType));
  const endpoint = `${baseUrl}/${instagramUserId}/insights`;

  const response = await axios.get(endpoint, {
    params: {
      metric: normalizedMetrics,
      period,
      access_token: token
    }
  });

  return response?.data;
};

export const getInstagramMediaInsights = async ({
  instagramMediaId,
  metrics,
  accessToken,
  loginType = 'facebook'
}) => {
  const normalizedMetrics = normalizeMetrics(metrics);
  const token = resolveAccessToken(accessToken);

  if (!instagramMediaId) {
    throw new Error('instagramMediaId es requerido');
  }
  if (!normalizedMetrics) {
    throw new Error('metrics es requerido');
  }
  if (!token) {
    throw new Error('accessToken es requerido');
  }

  const baseUrl = normalizeBaseUrl(resolveBaseUrl(loginType));
  const endpoint = `${baseUrl}/${instagramMediaId}/insights`;

  const response = await axios.get(endpoint, {
    params: {
      metric: normalizedMetrics,
      access_token: token
    }
  });

  return response?.data;
};
